/* INTEGY V680 — URL-state synchronization for collection stock/sort controls.
   - Clearance stock state is canonicalized by the head/V568 owners to integy_stock.
   - This late pass makes the visible sort UI follow sort_by after pagination or
     history navigation, even when Shopify's collection.sort_by Liquid value is stale.
   It does not own product membership, filtering, sorting, or pagination. */
(function(){
  'use strict';
  if (window.IntegyV680StateFix) return;
  window.IntegyV680StateFix = { version: 'V680', purpose: 'clearance-stock-url-and-sort-ui-sync' };
  var root = document.documentElement;
  root.classList.add('integy-v680');

  function sortValue(){
    try { return new URLSearchParams(location.search || '').get('sort_by') || ''; }
    catch (error) { return ''; }
  }
  function syncSort(){
    var value = sortValue();
    if (!value) return;
    Array.prototype.slice.call(document.querySelectorAll('select[data-productgrid-trigger-sort],select[name="sort_by"],.utils-sortby-select')).forEach(function(select){
      var found = Array.prototype.some.call(select.options || [], function(option){ return option.value === value; });
      if (found && select.value !== value) {
        select.value = value;
        try { select.dispatchEvent(new Event('integy:sort-ui-sync')); } catch (error) {}
      }
      select.setAttribute('data-integy-v680-sort-sync', value);
    });
    Array.prototype.slice.call(document.querySelectorAll('[data-productgrid-sort-content] button[value],.utils-sortby--modal-button[value]')).forEach(function(button){
      var active = button.value === value || button.getAttribute('value') === value;
      button.classList.toggle('utils-sortby--modal-button--active', active);
      if (active) button.setAttribute('disabled','disabled'); else button.removeAttribute('disabled');
    });
    root.setAttribute('data-integy-v680-sort', value);
  }
  function schedule(){
    syncSort();
    setTimeout(syncSort, 120);
    setTimeout(syncSort, 650);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once:true });
  else schedule();
  window.addEventListener('pageshow', schedule);
  window.addEventListener('popstate', schedule);
})();
